import React from "react";
import { useAuth } from "../context/AuthContext";
import { isManagerRole } from "../lib/roles";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CallLogTab } from "../components/calling/CallLogTab";
import { NumbersTab } from "../components/calling/NumbersTab";
import { SettingsTab } from "../components/calling/SettingsTab";

export default function Calling() {
  const { user, activeSubId } = useAuth();
  const isAgency = isManagerRole(user?.role);
  if (!activeSubId) return null;
  return (
    <div className="space-y-6 animate-fade-up max-w-6xl" data-testid="calling-page">
      <div>
        <h1 className="text-3xl font-display font-bold">Calls</h1>
        <p className="text-sm text-muted-foreground mt-1">Call leads from your browser with a headset. Each lead is dialed from your UK or US number to match their country.</p>
      </div>
      <Tabs defaultValue="log">
        <TabsList>
          <TabsTrigger value="log" data-testid="calling-tab-log">Call log</TabsTrigger>
          <TabsTrigger value="numbers" data-testid="calling-tab-numbers">Numbers</TabsTrigger>
          <TabsTrigger value="settings" data-testid="calling-tab-settings">Rules & compliance</TabsTrigger>
        </TabsList>
        <TabsContent value="log" className="mt-6"><CallLogTab subId={activeSubId} /></TabsContent>
        <TabsContent value="numbers" className="mt-6"><NumbersTab subId={activeSubId} isAgency={isAgency} /></TabsContent>
        <TabsContent value="settings" className="mt-6"><SettingsTab subId={activeSubId} isAgency={isAgency} /></TabsContent>
      </Tabs>
    </div>
  );
}
